import { Component, computed, inject, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../../../apps/cinari-erp-client/src/app/store/app.reducers';
import { MapsService } from '@zayan-erp/home-building';
import { MappingLot } from '@zayan-erp/home-building';
import { DropdownData } from '@zayan-erp/shared';
import { SvgIconsComponent } from '@zayan-erp/shared';
import { GenericDropdownComponent } from '@zayan-erp/shared';

export interface MapPoint {
  lotCoordinateMapping: {
    x: number;
    y: number;
  };
  lotId: string;
}

@Component({
  selector: 'app-mapping-popup',
  standalone: true,
  imports: [FormsModule, SvgIconsComponent, GenericDropdownComponent],
  templateUrl: './mapping-popup.component.html',
  styleUrl: './mapping-popup.component.scss'
})
export class MappingPopupComponent {
  visible = input<boolean>(false);
  coordinates = input<{ x: number; y: number } | null>(null);
  lots = input<MappingLot[]>([]);

  pointSaved = output<MapPoint>();
  pointCancelled = output<void>();

  _store = inject(Store<AppState>);
  _mappingService = inject(MapsService);

  selectedLot = signal<string | null>(null);
  markSaved = this._mappingService.markSaved$;

  lotsDD = computed<DropdownData[]>(() =>
    this.lots().map((lot: MappingLot) => ({
      id: lot.lotId,
      firstLabel: lot.lotNumber,
      secondLabel: ''
    }))
  );

  onSave() {
    if (this.coordinates() && this.selectedLot()?.trim()) {
      const point: MapPoint = {
        lotCoordinateMapping: {
          x: this.coordinates()!.x,
          y: this.coordinates()!.y
        },
        lotId: this.selectedLot() ?? ''
      };
      this._mappingService.mapCoordinates(point).subscribe({
        next: () => {
          this.pointSaved.emit(point);
          this._mappingService.markSaved.next();
          this.resetForm();
        }
      });
    }
  }

  onCancel() {
    this.pointCancelled.emit();
    this.resetForm();
  }

  private resetForm() {
    this.selectedLot.set(null);
  }
}
